import { render, staticRenderFns } from "./waitingForDocuments.vue?vue&type=template&id=24e8591d"
import script from "./waitingForDocuments.vue?vue&type=script&lang=js"
export * from "./waitingForDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports